import { render, staticRenderFns } from "./SideMenuAccount.vue?vue&type=template&id=59aa865b&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59aa865b')) {
      api.createRecord('59aa865b', component.options)
    } else {
      api.reload('59aa865b', component.options)
    }
    module.hot.accept("./SideMenuAccount.vue?vue&type=template&id=59aa865b&", function () {
      api.rerender('59aa865b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/SideMenuAccount.vue"
export default component.exports